import React from "react";
import {connect} from "react-redux";
import {withCommands} from "./CommandsProvider";
import moment from "moment";
import * as at from "../actionTypes";


export class UnconnectedHistoryItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingHistory: false
    }
    this.toggleSelected = this.toggleSelected.bind(this)
    this.fetchHistory = this.fetchHistory.bind(this)
  }


  fetchHistory(jobType) {
    this.setState({loadingHistory: true})
    this.props.commands.loadHistory(jobType || this.props.jobType, this.props.item.key)
      .then(x => {
        this.setState({
          loadingHistory: false,
          history: x
        })
      })
  }

  componentDidMount() {
    this.fetchHistory()
    this.intervalTimer = setInterval(this.fetchHistory, 15000);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.jobType !== this.props.jobType) {
      this.fetchHistory(nextProps.jobType)
    }
  }

  clearIntervalTimer() {
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer)
    }
  }

  componentWillUnmount() {
    this.clearIntervalTimer()
  }

  toggleSelected() {
    this.props.dispatch({ type: at.TOGGLE_ITEM, item: this.props.item })
  }

  render() {
    const { title, description, id, selected } = this.props.item
    const { loadingHistory, history } = this.state
    return <div
      className="clearfix card"
    >
      <div className={`card-header ${selected ? 'bg-primary text-white' : ''}`}
           style={{cursor: 'pointer'}}
           onClick={this.toggleSelected}>
        <h4>{title}</h4>
        <small><em>{`${id} - ${description}`}</em></small>
      </div>
      <div className="card-body">
        {
          loadingHistory ? <i className="fas fa-spinner fa-spin pull-right" /> :
            <a className="pull-right" onClick={() => this.fetchHistory()}><i className="far fa-sync-alt" /></a>
        }
        {
          history && <HistorySummary history={history}/>
        }
      </div>
    </div>
  }
}


export const HistoryItem = withCommands(connect(function mapStateToProps(state, ownProps) {
  const { queueJobsSummary, selectedJobType } = state.manageTool;
  return {
    ...ownProps, queueJobsSummary, jobType: selectedJobType
  }
})(UnconnectedHistoryItem))


export const HistorySummary = ({history}) => {
  let lastQueud = history.inProgress
    .concat(history.lastCompleted ? [history.lastCompleted] : [])
    .map(x => x.queueTime.$date)
    .sort((a, b) => a - b)
    .reverse();

  let format = "dddd, MMMM Do YYYY, h:mm:ss a";

  lastQueud = lastQueud[0] ? moment(lastQueud[0]).format(format) : 'Never';

  let lastCompleted = history.lastCompletedTime ? moment(history.lastCompletedTime.$date).format(format) : 'Never';

  return <div>
    <div><strong>Jobs In Progress:</strong> {
      history.inProgress.length ?
        <a
          target="_blank"
          href={
            '/manageTool/viewLogs?' + history.inProgress.map(x => `jobItemIds=${x.id}`).join('&')
          }>{history.inProgress.length}</a> :
        <span>{ history.inProgress.length }</span>
    }</div>
    <div><strong>Last Queued:</strong> {lastQueud}</div>
    <div><strong>Last Completed:</strong> {
      history.lastCompleted ? <a
        target="_blank"
        href={'/manageTool/viewLogs?jobItemIds=' + history.lastCompleted.id}>
        {lastCompleted}
      </a> : <span>{lastCompleted}</span>
    }</div>
    <div><strong>Last Completed Status:</strong> {history.lastCompletedStatus || 'None'}</div>
  </div>
}
